import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../img/header/logo.svg';
import Socials from './Socials.js';
import MobileNav from './MobileNav.js';

const Header = () => {
  return (
    <header className='fixed w-full px-[30px] lg:px-[100] z-30 h-[100px] lg:h-[140px] flex items-center'>
      <div className='flex flex-col lg:flex-row lg:items-center w-full justify-between'>
        <Link to={'/'} className='max-w-[150px] md:max-w-[200px]'>
          <img src={Logo} alt=' ' style={{ width: '100%', padding: '10px 20px' }} />
        </Link>
        {/* Nav items */}
        <nav className='hidden xl:flex gap-x-12' style={{ marginTop: '20px' }}>
          <Link to={'/'} className='text-[#FFD700] font-bold hover:text-white hover:text-white transition text-lg'>
            Home
          </Link>
          <Link to={'/about'} className='text-[#FFD700] font-bold hover:text-white hover:text-white transition text-lg'>
            About
          </Link>
          <Link to={'/portfolio'} className='text-[#FFD700] font-bold hover:text-white hover:text-white transition text-lg'>
            Portfolio
          </Link>
          <Link to={'/contact'} className='text-[#FFD700] font-bold hover:text-white hover:text-white transition text-lg'>
            Contact
          </Link>
        </nav>

      </div>
      {/* Socials */}
      <Socials />
      {/* Mobilenav */}
      <MobileNav />
    </header>
  );
};

export default Header;
